module.exports = __webpack_public_path__ + "img/florasprings-logo.7061593c.png";